import React, { useContext, useEffect, useState } from 'react'
import { InputDiv, StyledSelect, StyledOption } from './style'
import ImportFromExcelContext from '../../../../../contexts/ImportFromExcelContext'

interface SpreadsheetColumnsSelectsProps {
  headerRow: any
  numberOfSelects: number
}

const SpreadsheetColumnsSelects: React.FC<SpreadsheetColumnsSelectsProps> = ({
  headerRow,
  numberOfSelects,
}) => {
  const columnNames = Object.keys(headerRow)
  const { translationMapping, setTranslationMapping } = useContext(
    ImportFromExcelContext,
  )
  const [selectedValues, setSelectedValues] = useState<string[]>(
    Array(numberOfSelects).fill(''),
  )

  useEffect(() => {
    const initialSelectedValues = Object.keys(translationMapping).slice(
      0,
      numberOfSelects,
    ) as string[]
    setSelectedValues(initialSelectedValues)
  }, [translationMapping, numberOfSelects])

  const handleSelectChange = (
    index: number,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    let columnName = e.target.value
    const alreadySelectedOption = Object.keys(translationMapping)

    if (alreadySelectedOption.includes(columnName)) {
      columnName = ''
    }

    if (columnName || columnName === '') {
      setTranslationMapping((prevMapping: any) => {
        const newMapping = { ...prevMapping }

        if (index >= 0 && index < Object.keys(newMapping).length) {
          const keys = Object.keys(newMapping)
          const updatedMapping: { [key: string]: any } = {}

          keys.forEach((key, i) => {
            if (i === index) {
              delete newMapping[key]
              updatedMapping[columnName] = ''
            } else {
              updatedMapping[key] = newMapping[key]
            }
          })

          return updatedMapping
        } else {
          newMapping[columnName] = undefined
          return newMapping
        }
      })
    }
  }

  const renderSpreadsheetColumnsSelects = () => {
    const columnSelects = Array.from({ length: numberOfSelects }, (_, i) => {
      const options = columnNames.map((key, index) => (
        <StyledOption key={index} value={key}>
          {headerRow[key]}
        </StyledOption>
      ))

      return (
        <InputDiv className='columns' key={i}>
          <StyledSelect
            key={selectedValues[i]}
            value={selectedValues[i]}
            onChange={(e) => handleSelectChange(i, e)}
          >
            <StyledOption value=''>
              Selecione
            </StyledOption>
            {options}
          </StyledSelect>
        </InputDiv>
      )
    })

    return columnSelects
  }

  return <>{renderSpreadsheetColumnsSelects()}</>
}

export default SpreadsheetColumnsSelects
